export default `<svg width="512" height="448" viewBox="0 0 512 448" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M64 448H448C483.3 448 512 419.3 512 384V128C512 92.7 483.3 64 448 64H288C277.9 64 268.4 59.3 262.4 51.2L243.2 25.6C231.1 9.5 212.1 0 192 0H64C28.7 0 0 28.7 0 64V384C0 419.3 28.7 448 64 448Z"
    fill="currentColor" />
</svg>`